
let base_color = "#BFFF7F";
let bolt_color = "#FFFFFF";
let detail_color = "#00FFBF";


export {
    base_color,
    bolt_color,
    detail_color
}
